import React from 'react';

function Pagination({ currentPage, totalPages, totalCount, onPageChange }) {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="ringtone-pagination-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px', paddingTop: '16px', borderTop: '1px solid #e2e8f0' }}>
      {totalCount !== undefined && totalCount !== null && (
        <span className="pagination-range-text" style={{ fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
          {(currentPage - 1) * 20 + 1}-{Math.min(currentPage * 20, totalCount)} of {totalCount}
        </span>
      )}

      <div className="pagination-controls-wrapper" style={{ display: 'flex', gap: '6px', alignItems: 'center', marginLeft: 'auto' }}>
        <button 
          type="button" 
          className="pager-btn outlined"
          disabled={currentPage === 1}
          onClick={() => onPageChange(1)}
          style={{
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #cbd5e1',
            background: '#ffffff',
            color: currentPage === 1 ? '#cbd5e1' : '#475569',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            fontSize: '12px',
            fontWeight: '600'
          }}
        >
          &lt;&lt;
        </button>
        <button 
          type="button" 
          className="pager-btn outlined"
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          style={{
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #cbd5e1',
            background: '#ffffff',
            color: currentPage === 1 ? '#cbd5e1' : '#475569',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            fontSize: '12px',
            fontWeight: '600'
          }}
        >
          &lt;
        </button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
          <button 
            key={num}
            type="button" 
            className={`pager-btn ${currentPage === num ? 'active' : 'outlined'}`}
            onClick={() => onPageChange(num)}
            style={{
              padding: '6px 12px',
              borderRadius: '6px',
              border: currentPage === num ? 'none' : '1px solid #cbd5e1',
              background: currentPage === num ? '#3b82f6' : '#ffffff',
              color: currentPage === num ? '#ffffff' : '#475569',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '600'
            }}
          >
            {num}
          </button>
        ))}
        <button 
          type="button" 
          className="pager-btn outlined"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          style={{
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #cbd5e1',
            background: '#ffffff',
            color: currentPage === totalPages ? '#cbd5e1' : '#475569',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            fontSize: '12px',
            fontWeight: '600'
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
}

export default Pagination;
